import React, { useEffect, useState } from "react";
import "../../style.css";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import { useSelector } from "react-redux";
const SelectGstinFilter = (props) => {
  // const {
  //   gstr2a2bNewCommonReducer: { selectedGstin },
  // } = useSelector((store) => store);
  const { selectedGstin } = useSelector(
    (store) => store.gstr2a2bNewCommonReducer
  );
  const [selectedValues, setSelectedValues] = useState(
    selectedGstin?.length > 0 ? selectedGstin : []
  );

  const handleGstin = (currentNode, selectedNodes) => {
    console.log("handleGstin called :: ", JSON.stringify(currentNode), JSON.stringify(selectedNodes), JSON.stringify(selectedGstin));
    let selectedFilter = [];
    if (currentNode.label === "All GSTIN") {
      // If "Select All" is toggled, update the state with all or none
      const allSelected = currentNode.checked; // Check if Select All is now checked
      setSelectedValues(allSelected ? selectedGstin : []);
      selectedFilter = (allSelected ? selectedGstin : [])
    } else {
      // Update state with selected node values for regular nodes
      selectedFilter = selectedNodes.map((node) => node.value)
      setSelectedValues(selectedFilter);
    }
    props.handleSubmit(false, "", selectedFilter);
  };
  useEffect(() => {
    console.log("selectedValues::", selectedValues);
    // props.handleSubmit(true, "", selectedValues);
  }, [selectedValues]);
  useEffect(() => {
    setSelectedValues(selectedGstin);
  }, [selectedGstin]);
  return (
    <div class="dropdown-container-gstr2a2b" style={{ width: "21%",zIndex:100 }}>
      <label
        style={{
          fontFamily: "GT-Walsheim-medium",
          fontSize: "9px",
          marginBottom: "0px",
        }}
      >
        Select GSTIN of Taxpayer*
      </label>
      <Container
        data={
          selectedGstin?.length > 0
            ? [
                {
                  label: "All GSTIN",
                  value: selectedValues.join(", "),
                  checked: selectedValues.length === selectedGstin.length, // Select All is checked if all items are selected
                  children: selectedGstin.map((item) => ({
                    label: item,
                    value: item,
                    checked: selectedValues.includes(item),
                  })),
                },
              ]
            : []
        }
        onChange={handleGstin}
        isDisabled={selectedGstin?.length === 0}
      />
    </div>
  );
};

export default SelectGstinFilter;
